module.exports = __webpack_public_path__ + "img/name.4fa397c5.svg";